import React, { useState } from "react";
import { overlayAPI } from "../services/api";
import "./ResourceSnapper.css";

const ResourceSnapper = ({ lessonId, teksId, onSuccess }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    resource_url: "",
    notes: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const canCreate = Boolean(lessonId || teksId);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const payload = {
        lesson_id: lessonId || null,
        teks_id: teksId || null,
        resource_url: formData.resource_url,
        notes: formData.notes,
      };

      await overlayAPI.create(payload);
      setFormData({ resource_url: "", notes: "" });
      setIsOpen(false);
      onSuccess?.();
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || "Could not save resource.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="snap-open-btn"
        type="button"
        onClick={() => setIsOpen(true)}
        data-tour="snap-resource-btn"
        disabled={!canCreate}
        title={!canCreate ? "Select a lesson first" : "Add personal resource"}
      >
        Add Resource
      </button>

      {isOpen && (
        <div className="snap-modal">
          <div className="snap-modal-content">
            <div className="snap-modal-header">
              <h3>Snap a Personal Resource</h3>
              <button className="snap-close-btn" type="button" onClick={() => setIsOpen(false)}>
                Close
              </button>
            </div>

            <form onSubmit={handleSubmit} className="snap-form">
              <div className="form-group">
                <label htmlFor="resource_url">
                  Resource Link
                </label>
                <input
                  type="url"
                  id="resource_url"
                  name="resource_url"
                  value={formData.resource_url}
                  onChange={handleInputChange}
                  placeholder="https://..."
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="notes">Notes (optional)</label>
                <textarea
                  id="notes"
                  name="notes"
                  value={formData.notes}
                  onChange={handleInputChange}
                  placeholder="Add notes about how to use this resource..."
                  rows="4"
                />
              </div>

              {error && <div className="error-message">{error}</div>}

              <div className="form-actions">
                <button type="submit" disabled={loading}>
                  {loading ? "Snapping..." : "Snap Resource"}
                </button>
                <button type="button" onClick={() => setIsOpen(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ResourceSnapper;
